export default "__VITE_ASSET__ucMMnBQz__"